import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ResolveStart, Router } from '@angular/router';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services/auth.service';
import { HomepageSetting } from 'src/app/modules/framework/home-pages/employee-home-page/models/HomepageSettings';
import { HomepageService } from 'src/app/modules/framework/home-pages/employee-home-page/services/homepage.service';
import { BreakpointObserverService } from 'src/app/shared/framework/navigation/services/breakpoint-observer.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  private routeObserver$: Observable<any>;
  public showScrollBtn = false;
  public isPublicPage: boolean = true;

  constructor(
    public layout: BreakpointObserverService,
    private authService: AuthService,
    private _homepageService: HomepageService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  /// Setting for Iframes
  showNav = false;
  showNavigation = false;
  showSideNav = false;
  layoutClass = '';
  mobileLayoutClass = '';
  routerObserver;
  querySubscriber;
  showFooter = false;
  private subscriptions: Subscription[] = [];

  ngOnInit() {
    this.routeObserver$ = this.router.events.pipe(
      filter((event) => event instanceof ResolveStart),
      map((event: ResolveStart) => {
        let data = null;
        let route = event['state'].root;

        while (route) {
          data = route.data || data;
          route = route.firstChild;
        }

        return data;
      })
    );

    this.routerObserver = combineLatest([
      this.routeObserver$,
      this.activatedRoute.queryParamMap
    ]).subscribe(([data, q]) => {
      let test = false;
      if (data.hasOwnProperty('showLayout') && data['showLayout']) {
        test = true;
      }

      if (q.has('source') && q.get('source') == 'hr') {
        test = false;
        this.showFooter = false;
      }

      this.layoutClass = test ? 'mainLayoutHolder' : '';
      this.mobileLayoutClass = test ? 'mainLayoutHolderMobile' : '';

      this.showNav = test;
      this.showFooter = this.showNav;
      if (data.hasOwnProperty('showFooter')) {
        if (data['showFooter']) {
          this.showFooter = true;
        } else {
          this.showFooter = false;
        }
      }

      this.isPublicPage = data['access'] == 'public';
    });

    this.loadAuthenticatedLayoutSettings();

  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // You can adjust the 200px threshold as needed
    this.showScrollBtn = (window.pageYOffset || document.documentElement.scrollTop) > 200;
  }
  scrollToTop() {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }
  ngOnDestroy(): void {
    this.routerObserver?.unsubscribe();
    this.querySubscriber?.unsubscribe();

    for (const subsc of this.subscriptions) {
      subsc.unsubscribe();
    }
  }

  private loadAuthenticatedLayoutSettings(): void {
    if (this.authService.isAuthenticated()) {
      this.loadLayoutSettingsForCurrentUser();
      return;
    }

    this.subscriptions.push(
      this.authService
        .isLoggedIn()
        .pipe(
          filter((isLoggedIn: boolean) => isLoggedIn),
          take(1)
        )
        .subscribe(() => {
          this.loadLayoutSettingsForCurrentUser();
        })
    );
  }

  private loadLayoutSettingsForCurrentUser(): void {
    this.subscriptions.push(
      this.authService.getUserRoles().pipe(take(1)).subscribe(() => {
        this.subscriptions.push(
          this._homepageService
            .getSettings(false)
            .pipe(take(1))
            .subscribe((settings: HomepageSetting[]) => {
              const isCorporateHrView = localStorage.getItem('corporatehr_view') === '1';
              const isLocalHrView = localStorage.getItem('localhr_view') === '1';
              const isDelegateView = localStorage.getItem('delegate_view') === '1';
              const isManagerView = localStorage.getItem('manager_view') === '1';
              const isMatrixManagerView = localStorage.getItem('matrixmanager_view') === '1';
              const isTrainerView = localStorage.getItem('trainer_view') === '1';

              if (localStorage.getItem('delegate_view') === '1') {
                this.showSideNav = settings.filter(e => e.isVisible && e.roleId == 333 && e.name == 'show_sidebar')[0]?.value;
              } else if (localStorage.getItem('manager_view') === '1') {
                this.showSideNav = settings.filter(e => e.isVisible && e.roleId == 33 && e.name == 'show_sidebar')[0]?.value;
              } else if (localStorage.getItem('trainer_view') === '1') {
                this.showSideNav = settings.filter(e => e.isVisible && e.roleId == 6 && e.name == 'show_sidebar')[0]?.value;
              } else if (localStorage.getItem('localhr_view') === '1') {
                this.showSideNav = settings.filter(e => e.isVisible && e.roleId == 2 && e.name == 'show_sidebar')[0]?.value;
              } else if (localStorage.getItem('corporatehr_view') === '1') {
                this.showSideNav = settings.filter(e => e.isVisible && e.roleId == 1 && e.name == 'show_sidebar')[0]?.value;
              } else {
                this.showSideNav = settings.filter(e => e.isVisible && e.roleId == 3 && e.name == 'show_sidebar')[0]?.value;
              }

              const isEmployeeView = !isCorporateHrView && !isLocalHrView && !isDelegateView && !isManagerView && !isMatrixManagerView && !isTrainerView;
              this.showNavigation = isEmployeeView;
            })
        );
      })
    );
  }
}
